import React from 'react';

import styles from '../../components/HelpBox/HelpBox.module.scss';

import Button from '../../components/Button/Button';
import {
  TAX_WITHHOLDING_STEP,
  helpColumnContent,
} from '../../settings/settings';

const WithHoldingDisclosureModal = ({ onClose }) => {
  const withHoldingcontent = helpColumnContent[TAX_WITHHOLDING_STEP];
  return (
    <div className={styles['taxmodal-container']}>
      <div className={styles['title-container']}>
        <div className="modal-title">{withHoldingcontent.altTitle}</div>
      </div>
      <div className={styles['text-container']}>
        {withHoldingcontent.subTopics.map((topic, key) => (
          <div key={key}>
            {topic.title && (
              <div className={styles.subHeading}>{topic.title}</div>
            )}
            {topic.description.map((withHoldingcontent, key) => (
              <div key={key} className={styles.subDescription}>
                {topic.emphasis && (
                  <span className={styles['emphasis']}>{topic.emphasis}</span>
                )}
                {withHoldingcontent}
              </div>
            ))}
          </div>
        ))}
      </div>
      <div className={styles['tax-button']} onClick={onClose}>
        <div></div>
        <Button id="close-tax-withholding-modal" type="primary" size="small">
          OK
        </Button>
      </div>
    </div>
  );
};

export default WithHoldingDisclosureModal;
